/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const JumboStructsMicrosoftDefenderOperatingSystem = {
    Windows11: 'windows11',
    Windows10: 'windows10',
    Windows81: 'windows8.1',
    WindowsLegacy: 'windows_legacy',
    WindowsServer2008R2: 'windows_server_2008_r2',
    WindowsServer2012: 'windows_server_2012',
    WindowsServer2012R2: 'windows_server_2012_r2',
    WindowsServer2016: 'windows_server_2016',
    WindowsServer2019: 'windows_server_2019',
    WindowsServer2022: 'windows_server_2022',
    WindowsServer2025: 'windows_server_2025',
    WindowsServerLegacy: 'windows_server_legacy',
    Macos: 'macos',
    Linux: 'linux'
} as const;
export type JumboStructsMicrosoftDefenderOperatingSystem = typeof JumboStructsMicrosoftDefenderOperatingSystem[keyof typeof JumboStructsMicrosoftDefenderOperatingSystem];


export function JumboStructsMicrosoftDefenderOperatingSystemFromJSON(json: any): JumboStructsMicrosoftDefenderOperatingSystem {
    return JumboStructsMicrosoftDefenderOperatingSystemFromJSONTyped(json, false);
}

export function JumboStructsMicrosoftDefenderOperatingSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsMicrosoftDefenderOperatingSystem {
    return json as JumboStructsMicrosoftDefenderOperatingSystem;
}

export function JumboStructsMicrosoftDefenderOperatingSystemToJSON(value?: JumboStructsMicrosoftDefenderOperatingSystem | null): any {
    return value as any;
}

